/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { OnboardingId } from "../../commons/types/OnboardingId";
import { UserId } from "../../commons/types/UserId";
import { OnboardingFlow } from "./OnboardingFlow";
export const Onboarding = core.serialization.object({
    id: OnboardingId,
    userId: UserId,
    flow: OnboardingFlow.optional(),
    currentStep: core.serialization.number(),
    completedAt: core.serialization.date().optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
